export default {
  accountInfo: (state) => state.accountInfo,
  logged: (state) => state.logged,
  listLanguage: (state) => state.listLanguage,
};
